import React from 'react';
import {
  Route,
  RouteComponentProps,
  RouteProps,
  withRouter,
} from 'react-router';
import { AuthHelper, setToken } from '../utils';

export type IProps = RouteComponentProps & Omit<RouteProps, 'render'>;
class ProtectedRoute extends React.Component<IProps, null> {
  constructor(props) {
    super(props);
    this.verifyAuth = this.verifyAuth.bind(this);
  }

  componentDidMount() {
    this.verifyAuth();
  }

  componentDidUpdate() {
    this.verifyAuth();
  }

  handleEmailVerifierToken(
    pathname: string,
    params: URLSearchParams,
    token: string,
    tokenSource: string,
  ) {
    const { history } = this.props;
    setToken(token);

    // Remove token from URL and update history
    params.delete(tokenSource);
    const newSearch = params.toString();
    const newUrl = `${pathname}${newSearch ? `?${newSearch}` : ''}`;
    history.replace(newUrl);
  }

  verifyAuth() {
    const { location } = this.props;
    const { pathname, search } = location;
    const params = new URLSearchParams(search);
    const authTokenFromSERP = params?.get('serp_token');
    const authTokenFromEmailVerifier = params?.get('email_verifier_token');
    const authTokenFromEmailSpamChecker = params?.get(
      'email_spam_checker_token',
    );
    if (
      authTokenFromSERP ||
      authTokenFromEmailVerifier ||
      authTokenFromEmailSpamChecker
    ) {
      const token =
        authTokenFromSERP ||
        authTokenFromEmailVerifier ||
        authTokenFromEmailSpamChecker;

      let tokenSource = '';
      if (authTokenFromSERP) {
        tokenSource = 'serp_token';
      } else if (authTokenFromEmailVerifier) {
        tokenSource = 'email_verifier_token';
      } else if (authTokenFromEmailSpamChecker) {
        tokenSource = 'email_spam_checker_token';
      }

      this.handleEmailVerifierToken(pathname, params, token, tokenSource);
    }

    if (!AuthHelper.isAuthenticated) {
      const userEmail = params.get('userEmail');
      params.delete('authToken');
      
      // If user is trying to access /growth-hub or any subpath, redirect to /login with utm_source=growth-hub
      if (pathname?.startsWith('/growth-hub')) {
        params.set('utm_source', 'growth-hub');
        AuthHelper.logout({
          pathName: '/login',
          query: params.toString(),
        });
      } else {
        AuthHelper.logout({
          fallbackTo: pathname,
          ...(userEmail && { query: params.toString() }),
        });
      }
    }
  }

  render() {
    const { component: Component, ...rest } = this.props;

    return (
      <Route
        {...rest}
        render={(props) =>
          AuthHelper.isAuthenticated ? <Component {...props} /> : null
        }
      />
    );
  }
}

export default withRouter(ProtectedRoute);
